$.ready(function() {
	if (game.panel.type === 'desktop') {
		game.panel.buildHelp(5);
	}

	else if (game.panel.type === 'mobile') {
		game.panel.buildHelp(6);
	}

	game.dimensions.width  = 1460;
	game.dimensions.height = 894;

	game.sounds.loadSounds({
		background: require('./sounds/BaseGame_AmbientSpinLoop.mp3'),
		anticipate: {
			'11': require('./sounds/anticipate/Anticipation.mp3'),
			'12': require('./sounds/anticipate/Anticipation.mp3'),
		},

		drop: {
			'0': [
				require('./sounds/drop/0/Drop_Wild.mp3'),
				require('./sounds/drop/0/Drop_Wild.mp3'),
				require('./sounds/drop/0/Drop_Wild.mp3'),
				require('./sounds/drop/0/Drop_Wild.mp3'),
				require('./sounds/drop/0/Drop_Wild.mp3') ],
			'11': [
				require('./sounds/drop/11/Drop_Bonus1.mp3'),
				require('./sounds/drop/11/Drop_Bonus2.mp3'),
				require('./sounds/drop/11/Drop_Bonus3.mp3'),
				require('./sounds/drop/11/Drop_Bonus4.mp3'),
				require('./sounds/drop/11/Drop_Bonus5.mp3') ],
			'12': [
				require('./sounds/drop/12/Drop_Scatter1.mp3'),
				require('./sounds/drop/12/Drop_Scatter2.mp3') ],
		},
		win: {
			'bigwin_1': require('./sounds/win/BigWin_1.mp3'),
			'bigwin_2': require('./sounds/win/BigWin_2.mp3'),
			'bigwin_3': require('./sounds/win/BigWin_3.mp3'),
		},
		freespin: {
			background: require('./sounds/freespin/Background.mp3'),
			outro: require('./sounds/freespin/Outro.mp3'),
		},
		pickbonus: {
			background: require('./sounds/pickbonus/Background.mp3'),
			pick: require('./sounds/pickbonus/Reveal.mp3'),
			outro: require('./sounds/pickbonus/Outro.mp3'),
		},

		boom: require('./sounds/boom.mp3'),
	});

	game.specials = {
		0: { reels: [ 1, 2, 3, 4 ], min: 1, ignoreSequential: true  },
		11: { reels: [ 0, 1, 2, 3, 4 ], min: 2, max: 3, anticipate: true },
		12: { reels: [ 0, 4 ], min: 1, max: 2, anticipate: true },
	};

	/* Freespin */
	{
		game.features.freespin = game.generateFreespin({ symbol: 11, triggerBanners: 3, banners: 1, outro: 3000 });

		game.features.freespin.on('init', function() {
			game.addClass('newbackground');
		});

		game.features.freespin.on('begin', function(e) {
			game.inRecall = e.detail.recall;

			if(game.inRecall) {
				game.panel.disable("lock");
				game.frame.reels[1].mine_shaft.attr('class', 'mine_shaft hide');
				game.frame.reels[2].mine_shaft.attr('class', 'mine_shaft hide');
				game.frame.reels[3].mine_shaft.attr('class', 'mine_shaft hide');
			}
		});

		game.features.freespin.on('finish', function() {
			setTimeout(function() {
				game.removeClass('newbackground');
			}, 2500);
		});
	}

	/* Expanding Wild */
	{
		game.on('spin_init', function() {
			game.frame.reels[1].mine_shaft.attr('class', 'mine_shaft hide');
			game.frame.reels[2].mine_shaft.attr('class', 'mine_shaft hide');
			game.frame.reels[3].mine_shaft.attr('class', 'mine_shaft hide');
		});

		game.on('spin_done', function() {
			if (game.feature.active !== 'freespin' && game.last.bomb) {
				if (game.last.bomb.length > 0) {
					for (var g = 0; g < game.last.bomb.length; g++) {
						var shaft = game.frame.reels[game.last.bomb[g]].mine_shaft;
						shaft.removeClass('hide');
						game.sounds.play('boom');
						shaft.addClass('boom');
					}
				}
			}
		});

		game.on('ui', function() {
			for (var i = 0; i < game.config.reels; i++) {
				game.frame.reels[i].mine_shaft = $.div().addClass('mine_shaft hide').appendTo(game.frame.reels[i]);
				$.div().appendTo(game.frame.reels[i].mine_shaft);
			}
		});
	}

	/* Pick Bonus */
	{
		game.features.pick_bonus = $.div('bonus-pick');
		game.features.pick_bonus.dimensions = {
			width: 1500,
			height: 780,
			font: 36,
		};

		game.features.pick_bonus.key = 'pick_bonus';
		game.features.pick_bonus.panning = $.div().addClass('panning').appendTo(game.features.pick_bonus);
		game.features.pick_bonus.panning.panSpot = [];

		var clickDisabled = false;

		game.features.pick_bonus.panning.on('click', 'panSpot', function() {
			var index = this.index();

			if (clickDisabled || game.features.pick_bonus.panning.panSpot[index].chosen) {
				return;
			}

			clickDisabled = true;
			game.features.pick_bonus.panning.panSpot[index].chosen = true;
			controller.socket.emit('feature', { name: 'pick_bonus', action: 'choose', index: index });
		});

		game.features.pick_bonus.methods = {
			init: function() {
				game.panel.hide(true);
				game.sounds.play([ 'pickbonus', 'background' ], { loop: true });
			},

			begin: function(response, recall) {
				clickDisabled = false;
				game.feature.messages.removeClass('hide');

				for (var i = 0; i < response.valueLength; i++) {
					game.features.pick_bonus.panning.panSpot.push($.div().addClass('panSpot _' + i));
					game.features.pick_bonus.panning.panSpot[i].appendTo(game.features.pick_bonus.panning);
					game.features.pick_bonus.panning.panSpot[i].chosen = false;
					$.div().appendTo(game.features.pick_bonus.panning.panSpot[i]);
					game.features.pick_bonus.panning.panSpot[i].attr('class', 'panSpot _' + i);
				}

				if (response.picks === 0) {
					clickDisabled = true;

					setTimeout(function() {
						controller.socket.emit('feature', { name: 'pick_bonus', action: 'finish' });
					}, 2000);
				}

				if (recall) {
					clickDisabled = true;
				}
			},

			choose: function(response, recall) {
				var picks = response.picks;

				game.sounds.play([ 'pickbonus', 'pick' ]);

				game.features.pick_bonus.panning.panSpot[response.index].addClass('picked');
				setTimeout(function() {
					game.features.pick_bonus.panning.panSpot[response.index].removeClass('picked');
					game.features.pick_bonus.panning.panSpot[response.index].addClass('reveal');
					game.features.pick_bonus.panning.panSpot[response.index].overall = $.div().addClass('overall').apply('meter', { value: 0 });
					game.features.pick_bonus.panning.panSpot[response.index].overall.appendTo(game.features.pick_bonus.panning.panSpot[response.index]);
					game.panel.registerCash(game.features.pick_bonus.panning.panSpot[response.index].overall);
					
					let denom_multiplier = game.panel.denom.get() || 1;
					
					game.features.pick_bonus.panning.panSpot[response.index].overall.set(response.won * denom_multiplier);
					resetCashToggle();
				}, 2200);

				if (picks === 0) {
					game.features.pick_bonus.panning.css({
						'z-index': '-1',
					});

					setTimeout(function() {
						game.features.pick_bonus.panning.panSpot[response.index].overall.remove();
						controller.socket.emit('feature', { name: 'pick_bonus', action: 'finish' });
					}, 6000);
				}

				else {
					setTimeout(function() {
						clickDisabled = false;
					}, 2000);
				}
			},

			finish: function(response, recall) {
				clickDisabled = true;
				game.sounds.fade([ 'pickbonus', 'background' ], 1, 0, 0.5);
				game.sounds.play([ 'pickbonus', 'outro' ]);

				game.features.pick_bonus.panning.css({
					'z-index': '-1',
				});


				if (recall) {
					game.feature.showMessage('outro', response.win);
					game.features.pick_bonus.removeClass('panning');
					game.last = game.old;
					return;
				}

				game.feature.showMessage('outro', response.win);

				setTimeout(function() {
					game.features.pick_bonus.panning.css({
						'z-index': null,
					});
					game.features.pick_bonus.removeClass('panning');
					game.feature.finish();
					game.panel.show(true);
				}, 4000);
			},
		};
	}
	
	// Meters are created in credits by default, this updates the meter to the appropriate value (cash or credit)
	// It is used twice to reset it to the previous value
	function resetCashToggle() {
		game.panel.toggleCash();
		game.panel.toggleCash();
	}

	game.on("spin_init", function() {
		if(game.last.scatters.pays.length > 0) {
			for(let i = 0; i < game.last.scatters.pays.length; i++) {
                if(game.last.scatters.pays[i][0] === 12) {
                    game.last.scatters.pays[i][2] = "pick_bonus";
                }
            }
		}
	});

	game.on("ready", function() {
		if(game.inRecall) {
			game.old = game.last;
		}
	});
});



/** WEBPACK FOOTER **
 ** ./public-src/primary.js
 **/